module.exports = __webpack_public_path__ + "img/beef-1.77366958.jpg";